<template>
  <div>
    <v-card>
      <v-card-title class="info-detail">
        <div class="text-center">
          مدرسه {{ $store.getters.schoolInfo.schoolName }}
        </div>
      </v-card-title>
      <div>
        <v-expansion-panels accordion>
          <v-expansion-panel :key="1">
            <v-expansion-panel-header>معرفی</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div class="pb-4 pt-5">
                  <span class="titleTxt">
                    جنسیت:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.jensiatString }}
                  </span>
                </div>
                <div class="pb-4">
                  <span class="titleTxt">
                    مجوزتدریس:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.sath }}
                  </span>
                </div>
                <div class="pb-4">
                  <span class="titleTxt">
                    تعداد طلبه ها:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.studentCount }}
                  </span>
                </div>
                <div v-if="$store.getters.schoolInfo.creationDate" class="pb-4">
                  <span class="titleTxt">
                    تاریخ تاسیس:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.creationDate }}
                  </span>
                </div>
                <div class="pb-4">
                  <div class="titleTxt">
                    معرفی:
                  </div>
                  <div class="introductionTxt">
                    {{ $store.getters.schoolInfo.introduction }}
                  </div>
                </div>
                <div class="pb-4" v-if="$store.getters.schoolInfo.prides">
                  <div class="titleTxt">
                    افتخارات:
                  </div>
                  <div class="introductionTxt">
                    {{ $store.getters.schoolInfo.prides }}
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :key="2">
            <v-expansion-panel-header>ارتباط با مدرسه</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div class="pb-4 pt-5" v-if="$store.getters.schoolInfo.address">
                  <span class="titleTxt">
                    آدرس:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.address }}
                  </span>
                </div>
                <div class="pb-4">
                  <span class="titleTxt">
                    تلفن:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.tell_1 }} -
                    {{ $store.getters.schoolInfo.tell_2 }}
                  </span>
                </div>
                <div class="pb-4" v-if="$store.getters.schoolInfo.email">
                  <span class="titleTxt">
                    ایمیل:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.email }}
                  </span>
                </div>
                <div class="pb-4" v-if="$store.getters.schoolInfo.webURL">
                  <span class="titleTxt">
                    آدرس سایت:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.webURL }}
                  </span>
                </div>
                <div class="pb-4" v-if="$store.getters.schoolInfo.lmsURL">
                  <span class="titleTxt">
                    آدرس سامانه آموزش مجازی:
                  </span>
                  <span class="introductionTxt">
                    {{ $store.getters.schoolInfo.lmsURL }}
                  </span>
                </div>
                <div
                  class="pb-4"
                  v-if="
                    $store.getters.schoolInfo.socialNetwork1 |
                      $store.getters.schoolInfo.socialNetwork2 |
                      $store.getters.schoolInfo.socialNetwork3 |
                      $store.getters.schoolInfo.socialNetwork4
                  "
                >
                  <span class="titleTxt">
                    شبکه های اجتماعی:
                  </span>
                  <div class="introductionTxt">
                    {{
                      $store.getters.schoolInfo.socialNetwork1 != ""
                        ? $store.getters.schoolInfo.socialNetwork1
                        : ""
                    }}
                    <br />
                    {{
                      $store.getters.schoolInfo.socialNetwork2 != ""
                        ? $store.getters.schoolInfo.socialNetwork2
                        : ""
                    }}
                    <br />
                    {{
                      $store.getters.schoolInfo.socialNetwork3 != ""
                        ? $store.getters.schoolInfo.socialNetwork3
                        : ""
                    }}
                    <br />
                    {{
                      $store.getters.schoolInfo.socialNetwork4 != ""
                        ? $store.getters.schoolInfo.socialNetwork4
                        : ""
                    }}
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :key="3">
            <v-expansion-panel-header>مسئولین مدرسه</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-if="isMobile">
                <app-personnel
                  v-for="item in $store.getters.schoolPersonnel"
                  :personnel="item"
                  :key="item.Serial"
                />
              </div>
              <div v-else>
                <v-data-table
                  :items="$store.getters.schoolPersonnel"
                  :headers="personnelHeaders"
                  item-key="Serial"
                  class="elevation-1 rounded"
                  :no-data-text="tableText"
                  :item-class="rowClass"
                  :footer-props="{
                    itemsPerPageAllText: 'همه',
                    itemsPerPageText: 'تعداد ردیف',
                  }"
                >
                  <template
                    v-slot:[`footer.page-text`]="{ pageStart, pageStop }"
                  >
                    از {{ pageStart }} تا {{ pageStop }}
                  </template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :key="4">
            <v-expansion-panel-header>اساتید</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-if="isMobile">
                <app-personnel
                  v-for="item in $store.getters.schoolTeachers"
                  :personnel="item"
                  :key="item.Serial"
                />
              </div>
              <div v-else>
                <v-data-table
                  :items="$store.getters.schoolTeachers"
                  :headers="teacherHeaders"
                  item-key="Serial"
                  class="elevation-1 rounded"
                  :no-data-text="tableText"
                  :item-class="rowClass"
                  :footer-props="{
                    itemsPerPageAllText: 'همه',
                    itemsPerPageText: 'تعداد ردیف',
                  }"
                >
                  <template
                    v-slot:[`footer.page-text`]="{ pageStart, pageStop }"
                  >
                    از {{ pageStart }} تا {{ pageStop }}
                  </template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :key="5">
            <v-expansion-panel-header>تصاویر</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="item in $store.getters.schoolPictures">
                <img class="imageDisplay" :src="item.largeData" />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>
  </div>
</template>
<script>
import PersonnelApp from "./PersonnelApp";
export default {
  components: {
    appPersonnel: PersonnelApp,
  },
  data() {
    return {
      tab: null,
      showModal: false,
      scrollY: 0,
      selectedIndex: -1,
      showDetails: false,
      preBase64Image: "data:image/jpg;base64, ",
      personnelHeaders: [
        {
          text: "نام",
          value: "Name",
          width: "20%",
        },
        {
          text: "نام خانوادگی",
          value: "FamilyName",
          width: "20%",
        },
        {
          text: "سمت",
          value: "Semat",
          width: "60%",
        },
      ],
      teacherHeaders: [
        {
          text: "نام",
          value: "Name",
          width: "20%",
        },
        {
          text: "نام خانوادگی",
          value: "FamilyName",
          width: "20%",
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    personnel() {
      return this.$store.getters.schoolPersonnel;
    },
    createPictures() {
      let cmp = "";
      for (item in this.$store.getters.schoolPictures) {
        cmp += `<img :src=\"data:image/jpg;base64, 
            ${item.largData}
            \"`;
      }
    },
  },
  created() {
    const serial = this.$route.params.id;
    this.$store.dispatch("getSchoolInfo", serial);
    this.$store.dispatch("getSchoolPersonnel", serial);
    this.$store.dispatch("getSchoolTeachers", serial);
    this.$store.dispatch("getSchoolPictures", serial);
  },
  methods: {
    createImages(pic) {
      if (
        index < this.$store.getters.schoolPictures.length &&
        this.$store.getters.schoolPictures[index].largData
      )
        return (
          "data:image/jpg;base64, " +
          this.$store.getters.schoolPictures[index].largData
        );
      else return null;
    },
    replaceNewLine(description) {
      const str = description.replace(/(?:\r\n|\r|\n)/g, "<br>");
      return str;
    },
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
    hideModal() {
      this.showModal = false;
    },
    rowClass(item) {
      let rowClass = item.description === "" ? "no-expand" : "";
      return rowClass;
    },
  },
};
</script>
<style>
.directionLTR {
  direction: ltr;
}
.introductionTxt {
  padding: 10px;
  margin: 0 5px;
}
.titleTxt {
  padding: 10px;
  margin: 5px;
  font-size: 1.1rem;
  font-weight: 600;
}
.imageDisplay {
  width: auto;
}
@media screen and (max-width: 600px) {
  .introductionTxt {
    padding: 10px;
    margin: 0 5px;
    display: block;
  }
  .imageDisplay {
    width: calc(100% - 30px);
  }
}
</style>
